import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysCheckConnectionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysCheckConnectionController.php
* @route '/api/company/{company}/elys/check-connection'
*/
const ElysCheckConnectionController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysCheckConnectionController.url(args, options),
    method: 'get',
})

ElysCheckConnectionController.definition = {
    methods: ["get","head"],
    url: '/api/company/{company}/elys/check-connection',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysCheckConnectionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysCheckConnectionController.php
* @route '/api/company/{company}/elys/check-connection'
*/
ElysCheckConnectionController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return ElysCheckConnectionController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysCheckConnectionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysCheckConnectionController.php
* @route '/api/company/{company}/elys/check-connection'
*/
ElysCheckConnectionController.get = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysCheckConnectionController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysCheckConnectionController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysCheckConnectionController.php
* @route '/api/company/{company}/elys/check-connection'
*/
ElysCheckConnectionController.head = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ElysCheckConnectionController.url(args, options),
    method: 'head',
})

export default ElysCheckConnectionController